<template>
    <FilterExpandCollapse
      label="Services"
      :expand="false"
      v-show="show"
      v-if="filterContext.type === 'medical' || filterContext.type === 'doctor'"
    >
    <!--should we show this for dental as well ?? ask this question to BA-->
      <!-- Need to put a key on the ShowMore component so that it will redraw completely when the data changes -->
      <!-- If we don't do this we will get DOM errors when the slot gets re-rendered                           -->
      <FilterShowMore :threshold="10" :topLength="3" :key="showMoreKey">
        <div v-for="service in services" :key="service.id">
          <hp5-semantic size-selection="xs">
            <input :id="`service-${service.id}`" type="checkbox" v-model="filterContext.cc" :value="service.id" />
            <label :for="`service-${service.id}`">{{ service.name }}</label
            >
          </hp5-semantic>
        </div>
      </FilterShowMore>
    </FilterExpandCollapse>
</template>
  
<script setup>

    const model = useFCPModel()
    const { filterContext, rawConcepts } = model
    const cc = computed(() => filterContext.value.cc)
    const term = computed(() => filterContext.value.term)
    const show = computed(() => services.value && services.value.length > 0)
    const showMoreKey = computed(() => JSON.stringify(services.value))
    const type = computed(() => filterContext.value.type)

    const services = computed(() => {
        return rawConcepts.value.filter(concept => concept.type == 'service')
    })

  </script>
  
<style scoped>
  label {
    padding-left: var(--spacing-xs);
  }
</style>